import type * as React from 'react';
import '@diligentcorp/atlas-web-component-icons/lib/ai-sparkle-default/index.js';

type AiSparkleDefaultIconSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export interface AiSparkleDefaultIconProps {
  size?: AiSparkleDefaultIconSize;
  /** Host color for currentColor paths — use Atlas `type.default` on cyan backgrounds. */
  iconColor?: string;
}

/** Atlas "AI sparkle default" — filled sparkles for translation / AI actions (Figma CEE-1048). */
export function AiSparkleDefaultIcon({ size = 'md', iconColor }: AiSparkleDefaultIconProps) {
  return (
    <dil-ai-sparkle-default-icon
      size={size}
      variant="outlined"
      aria-hidden="true"
      style={iconColor ? { color: iconColor } : undefined}
    />
  );
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'dil-ai-sparkle-default-icon': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & {
          size?: AiSparkleDefaultIconSize;
          variant?: string;
        },
        HTMLElement
      >;
    }
  }
}
